import { apiSlice } from '../apiSlice';
import {
	HealthAssessmentResultDTO,
	HealthDetailListFilter,
	HealthDetailRequest,
	HealthDetailResultDTO,
	HealthExerciseDTO,
} from '../DTO/app-setting/health.interface';
import { SuccessResponse, Paginated } from '../DTO/common.interface';

export const healthApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getHealthList: builder.query<
			SuccessResponse<HealthAssessmentResultDTO[]>,
			null
		>({
			query: () => ({
				url: `/web/health/assessment-result/list`,
				method: 'GET',
			}),
		}),
		getHealthDetail: builder.query<
			SuccessResponse<HealthDetailResultDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/health/assessment-result/${id}`,
				method: 'GET',
			}),
			providesTags: ['HealthDetail'],
		}),
		updateHealthDetail: builder.mutation<
			SuccessResponse<any>,
			HealthDetailRequest
		>({
			query: (body) => ({
				url: `/web/health/assessment-result`,
				method: 'PUT',
				body,
			}),
			invalidatesTags: ['HealthDetail'],
		}),
		deleteHealthDetailList: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/health/assessment-result/exercise`,
				method: 'DELETE',
				body,
			}),
			invalidatesTags: ['HealthDetail'],
		}),
		getHealthDetailList: builder.query<
			SuccessResponse<Paginated<HealthExerciseDTO>>,
			HealthDetailListFilter
		>({
			query: (body) => ({
				url: `/web/health/assessment-result/${body.id}/exercise/page`,
				method: 'POST',
				body,
			}),
		}),
		createHealthDetailList: builder.mutation<
			SuccessResponse<any>,
			{ arr: string[]; id: string }
		>({
			query: (body) => ({
				url: `/web/health/assessment-result/${body.id}/exercise`,
				method: 'POST',
				body: body.arr,
			}),
			invalidatesTags: ['HealthDetail'],
		}),
		sortHealthDetailList: builder.mutation<SuccessResponse<any>, string[]>({
			query: (body) => ({
				url: `/web/health/assessment-result/exercise/sort`,
				method: 'POST',
				body: body,
			}),
			invalidatesTags: ['HealthDetail'],
		}),
	}),
});

export const {
	useGetHealthListQuery,
	useGetHealthDetailQuery,
	useUpdateHealthDetailMutation,
	useGetHealthDetailListQuery,
	useDeleteHealthDetailListMutation,
	useCreateHealthDetailListMutation,
	useSortHealthDetailListMutation,
} = healthApiSlice;
